import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "success-page" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "top" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  class: "ellipsis",
  style: {"text-align":"center","width":"100%"}
}
const _hoisted_6 = { class: "mid" }
const _hoisted_7 = { class: "mid-item" }
const _hoisted_8 = { class: "ellipsis" }
const _hoisted_9 = { class: "mid-item" }
const _hoisted_10 = {
  selectable: true,
  "user-select": true
}

import LogoImg from '@/assets/images/logo.png';
import { useLoading } from '@/hooks/useLoading';
import bannerImg from '@/assets/images/banner.jpg';
import {
  useBaseAsync,
  useRoute,
} from 'hpsfir-managebase-ui';
import { ref } from 'vue';
import { useApi } from '@/hooks/useApi';


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const route = useRoute();
const returnData = ref(history.state?.data || {});
console.log(returnData);
const loading = useLoading();

const directOpendoor = useBaseAsync(async(storeId: number) => {
  try {
    loading.show('开锁中');
    const res = await useApi().storeApi.opendoorByDirectstore({
      storeId,
    });
    returnData.value = res?.data?.data || {};
  } finally {
    loading.hide();
  }
});

if (route.query.storeId) {
  directOpendoor(Number(route.query.storeId as string));
}

return (_ctx: any,_cache: any) => {
  const _component_nut_avatar = _resolveComponent("nut-avatar")!

  return (_openBlock(), _createElementBlock("view", _hoisted_1, [
    _createElementVNode("img", {
      src: _unref(bannerImg),
      class: "radius",
      style: {"width":"100%","margin-bottom":"2px"}
    }, null, 8, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_nut_avatar, {
        size: "large",
        shape: "round",
        style: {"overflow":"hidden"}
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", { src: _unref(LogoImg) }, null, 8, _hoisted_4)
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_5, _toDisplayString(returnData.value?.storeName || ''), 1)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _cache[0] || (_cache[0] = _createElementVNode("span", { class: "label solid-cell" }, "开门状态", -1)),
        _createElementVNode("span", _hoisted_8, _toDisplayString(returnData.value?.statusMsg || '开门成功'), 1)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _cache[1] || (_cache[1] = _createElementVNode("span", { class: "label solid-cell" }, "店主手机号", -1)),
        _createElementVNode("text", _hoisted_10, _toDisplayString(returnData.value?.storePhone || ''), 1)
      ])
    ]),
    (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(loading).cnt)))
  ]))
}
}

})